// import { defaultNetworkService } from '../../../../../services/network'
import axios from "axios";
import { takeLatest, call, put, select, takeEvery, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../../utils/queryParams.js";

export const SET_LOADING = "saga/SET_LOADING";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "saga/FETCH_CURRENT_USER_FAILURE";
export const UPDATE_ALL_DATA = "saga/UPDATE_ALL_DATA";
export const UPDATE_ALL_DATA_SUCCESS = "saga/UPDATE_ALL_DATA_SUCCESS";
export const UPDATE_ALL_DATA_FAILURE = "saga/UPDATE_ALL_DATA_FAILURE";
export const FETCH_TOP_PERFORMERS = "saga/FETCH_TOP_PERFORMERS";
export const FETCH_TOP_PERFORMERS_SUCCESS = "saga/FETCH_TOP_PERFORMERS_SUCCESS";
export const FETCH_TOP_PERFORMERS_FAILURE = "saga/FETCH_TOP_PERFORMERS_FAILURE";
export const FETCH_POOR_PERFORMERS = "saga/FETCH_POOR_PERFORMERS";
export const FETCH_POOR_PERFORMERS_SUCCESS = "saga/FETCH_POOR_PERFORMERS_SUCCESS";
export const FETCH_POOR_PERFORMERS_FAILURE = "saga/FETCH_POOR_PERFORMERS_FAILURE";
export const FETCH_CLASS_BY_TYPE = "saga/FETCH_CLASS_BY_TYPE";
export const FETCH_CLASS_BY_TYPE_SUCCESS = "saga/FETCH_CLASS_BY_TYPE_SUCCESS";
export const FETCH_CLASS_BY_TYPE_FAILURE = "saga/FETCH_CLASS_BY_TYPE_FAILURE";
export const FETCH_VISITS_BY_TYPE = "saga/FETCH_VISITS_BY_TYPE";
export const FETCH_VISITS_BY_TYPE_SUCCESS = "saga/FETCH_VISITS_BY_TYPE_SUCCESS";
export const FETCH_VISITS_BY_TYPE_FAILURE = "saga/FETCH_VISITS_BY_TYPE_FAILURE";
export const REMOVE_CLASS_CATEGORY = "saga/REMOVE_CLASS_CATEGORY";
export const REMOVE_CLASS_CATEGORY_FAILURE = "saga/REMOVE_CLASS_CATEGORY_FAILURE";
export const REMOVE_CLASS_CATEGORY_SUCCESS = "saga/REMOVE_CLASS_CATEGORY_SUCCESS";
export const ADD_CLASS_CHART = "saga/ADD_CLASS_CHART";
export const ADD_CLASS_CHART_SUCCESS = "saga/ADD_CLASS_CHART_SUCCESS";
export const ADD_CLASS_CHART_FAILURE = "saga/ADD_CLASS_CHART_FAILURE";
export const SET_CLASS_TYPES_CHECKED = "saga/SET_CLASS_TYPES_CHECKED";
export const SET_CLASS_TYPES_CHECKED_SUCCESS = "saga/SET_CLASS_TYPES_CHECKED_SUCCESS";
export const SET_CLASS_TYPES_CHECKED_FAILURE = "saga/SET_CLASS_TYPES_CHECKED_FAILURE";
export const FETCH_ALL_CLASSES_BY_TYPE = "saga/FETCH_ALL_CLASSES_BY_TYPE";
export const FETCH_ALL_CLASSES_BY_TYPE_SUCCESS = "saga/FETCH_ALL_CLASSES_BY_TYPE_SUCCESS";
export const FETCH_ALL_CLASSES_BY_TYPE_FAILURE = "saga/FETCH_ALL_CLASSES_BY_TYPE_FAILURE";

// const axios = defaultNetworkService()

let date;

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateAllData: createAction(UPDATE_ALL_DATA),
  fetchTopPerfomers: createAction(FETCH_TOP_PERFORMERS),
  fetchPoorPerfomers: createAction(FETCH_POOR_PERFORMERS),
  fetchClassByType: createAction(FETCH_CLASS_BY_TYPE),
  fetchVisitsByType: createAction(FETCH_VISITS_BY_TYPE),
  removeClassCategory: createAction(REMOVE_CLASS_CATEGORY),
  addClassChart: createAction(ADD_CLASS_CHART),
  setClassTypesChecked: createAction(SET_CLASS_TYPES_CHECKED),
  getAllClassesByTypeData: createAction(FETCH_ALL_CLASSES_BY_TYPE_SUCCESS)
};
export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_ALL_DATA, updateAllData);
  yield takeLatest(FETCH_TOP_PERFORMERS, getTopPerformers);
  yield takeLatest(FETCH_POOR_PERFORMERS, getPoorPerformers);
  yield takeLatest(FETCH_CLASS_BY_TYPE, getClassByTypeData);
  yield takeLatest(FETCH_VISITS_BY_TYPE, getVisitsByTypeData);
  yield takeEvery(REMOVE_CLASS_CATEGORY, removeClassCategory);
  yield takeLatest(ADD_CLASS_CHART, addClassChart);
}

export function* getCurrentUserData(data) {
  // Get user data first. Once we confirm we have user data pass to other sagas and call them.
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: data.payload.user });

  date = data.payload.date || (yield select(state => state.attendance.currentUser.calendarEndDate));

  let id = yield select(state => state.attendance.currentUser.organization_id);
  let objectId = yield select(state => state.attendance.currentUser.current_object_id);
  let locationId = yield select(state => state.attendance.currentUser.current_location_id);
  let regionId = yield select(state => state.attendance.currentUser.current_region_id);
  let allSagas = [
    getTopPerformers(id, objectId, locationId, regionId, date),
    getPoorPerformers(id, objectId, locationId, regionId, date),
    getClassByTypeData(id, objectId, locationId, regionId, date),
    getVisitsByTypeData(id, objectId, locationId, regionId, date),
    getAllClassesByTypeData(id, objectId, locationId, regionId, date)
  ];
  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateAllData(month) {
  // Get user data first. Once we confirm we have user data pass to other sagas and call them.
  yield put({ type: SET_LOADING, payload: true });

  date = month.payload;

  let id = yield select(state => state.attendance.currentUser.organization_id);
  let objectId = yield select(state => state.attendance.currentUser.current_object_id);
  let locationId = yield select(state => state.attendance.currentUser.current_location_id);
  let regionId = yield select(state => state.attendance.currentUser.current_region_id);

  let allSagas = [
    getTopPerformers(id, objectId, locationId, regionId, date),
    getPoorPerformers(id, objectId, locationId, regionId, date),
    getClassByTypeData(id, objectId, locationId, regionId, date),
    getVisitsByTypeData(id, objectId, locationId, regionId, date),
    getAllClassesByTypeData(id, objectId, locationId, regionId, date)
  ];
  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* getTopPerformers(id, objectId, locationId, regionId, date) {
  try {
    const topPerformersResponse = yield call(
      axios.get,
      queryParams.apiVersion +
        "attendance/top_performers" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date
    );
    yield put({ type: FETCH_TOP_PERFORMERS_SUCCESS, payload: topPerformersResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_TOP_PERFORMERS_FAILURE, error });
  }
}

export function* getPoorPerformers(id, objectId, locationId, regionId, date) {
  try {
    const poorPerformersResponse = yield call(
      axios.get,
      queryParams.apiVersion +
        "attendance/poor_performers" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date
    );
    yield put({ type: FETCH_POOR_PERFORMERS_SUCCESS, payload: poorPerformersResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_POOR_PERFORMERS_FAILURE, error });
  }
}

export function* getClassByTypeData(id, objectId, locationId, regionId, date) {
  try {
    const revenueByTypeResponse = yield call(
      axios.get,
      queryParams.apiVersion +
        "attendance/class_by_type_attendance" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date
    );
    yield put({ type: FETCH_CLASS_BY_TYPE_SUCCESS, payload: revenueByTypeResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_CLASS_BY_TYPE_FAILURE, error });
  }
}

export function* getAllClassesByTypeData(id, objectId, locationId, regionId, date) {
  try {
    const getClassByTypeResponse = yield call(
      axios.get,
      queryParams.apiVersion +
        "attendance/all_classes_by_type" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date
    );
    yield put({ type: FETCH_ALL_CLASSES_BY_TYPE_SUCCESS, payload: getClassByTypeResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_ALL_CLASSES_BY_TYPE_FAILURE, error });
  }
}

export function* getVisitsByTypeData(id, objectId, locationId, regionId, date) {
  try {
    const visitsByTypeResponse = yield call(
      axios.get,
      queryParams.apiVersion +
        "attendance/visits_by_type" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date
    );
    yield put({ type: FETCH_VISITS_BY_TYPE_SUCCESS, payload: visitsByTypeResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_VISITS_BY_TYPE_FAILURE, error });
  }
}

export function* removeClassCategory() {
  let charts = yield select(state => state.attendance.classByTypeAttendance);

  let chartsToPush = [];
  charts.map(items => {
    chartsToPush.push(items.id);
  });

  let id = yield select(state => state.attendance.currentUser.organization_id);
  let objectId = yield select(state => state.attendance.currentUser.current_object_id);
  let locationId = yield select(state => state.attendance.currentUser.current_location_id);
  let regionId = yield select(state => state.attendance.currentUser.current_region_id);
  try {
    const response = yield call(
      axios.put,
      queryParams.apiVersion +
        "attendance/set_default_class_type_ids" +
        "?default_class_type_ids[]=" +
        chartsToPush[0] +
        "&default_class_type_ids[]=" +
        chartsToPush[1] +
        "&default_class_type_ids[]=" +
        chartsToPush[2] +
        "&default_class_type_ids[]=" +
        chartsToPush[3] +
        "&organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "" +
        "&date=" +
        date
    );
    yield put({ type: REMOVE_CLASS_CATEGORY_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: REMOVE_CLASS_CATEGORY_FAILURE, error });
  }
}

export function* setClassTypesChecked(action) {
  try {
    yield put({ type: SET_CLASS_TYPES_CHECKED_SUCCESS, payload: action.payload });
  } catch (error) {
    console.error(error);
    yield put({ type: SET_CLASS_TYPES_CHECKED_FAILURE, error });
  }
}

export function* addClassChart() {
  let id = yield select(state => state.attendance.currentUser.organization_id);
  let objectId = yield select(state => state.attendance.currentUser.current_object_id);
  let locationId = yield select(state => state.attendance.currentUser.current_location_id);
  let regionId = yield select(state => state.attendance.currentUser.current_region_id);
  let chartId = yield select(state => state.attendance.classByTypeAttendanceChecked);
  try {
    const response = yield call(
      axios.put,
      queryParams.apiVersion +
        "attendance/set_default_class_type_ids" +
        "?default_class_type_ids[]=" +
        chartId[0] +
        "&default_class_type_ids[]=" +
        chartId[1] +
        "&default_class_type_ids[]=" +
        chartId[2] +
        "&default_class_type_ids[]=" +
        chartId[3] +
        "&organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "" +
        "&date=" +
        date
    );
    yield put({ type: ADD_CLASS_CHART_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: ADD_CLASS_CHART_FAILURE, error });
  }
}
